
import { Component, Prop, Vue } from 'vue-property-decorator';
import Button from '@/components/UI/button/Button.vue';
import ServicesForm from '@/views/AirRoad/components/ServicesForm.vue';
import { AirRoadBookingSpecialOptions, AirRoadJobData, ARServiceItemList } from '@/models/airRoad';
import { statesTimeZonesList, timeZoneDefault } from '@/utils/PortalConstants';

import { format, utcToZonedTime } from 'date-fns-tz';
import { convertTimeString12to24 } from '@/utils/InputProcessingUtilities';

import { extend } from 'vee-validate';
import { required, regex } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'This field is required',
});
extend('regex', {
  ...regex,
  message: 'Numbers only',
});
@Component({
  components: { Button, ServicesForm },
})
export default class Services extends Vue {
  @Prop(Boolean) loading!: boolean;
  @Prop(Number) currentLegNumber!: number;
  @Prop(Array) jobsToBook!: Array<AirRoadJobData>;
  @Prop(Object) ARServicesDeliveryList!: ARServiceItemList;
  @Prop(Object) ARServicesPickupList!: ARServiceItemList;

  backBtnClicked(): void {
    this.$emit('backBtnClicked');
  }

  private createARServicesObject(servicesList: ARServiceItemList, is_pickup: boolean): AirRoadBookingSpecialOptions[] {
    return Object.values(servicesList)
      .filter(service => !!service.chosen)
      .map(service => {
        const state = this.jobsToBook[0].stops[this.currentLegNumber - 1].state;
        const stopTimeZone = statesTimeZonesList[state].timezone || timeZoneDefault;
        const zoneString = format(utcToZonedTime(new Date(), stopTimeZone), 'xxx', {
          timeZone: stopTimeZone,
        });

        let newDateTime: string | null = null;
        let newDateFrom: string | null = null;
        let newDateTo: string | null = null;

        if (service.date && service.time) {
          const date = format(new Date(service.date), 'yyyy-MM-dd');
          const newTimeValue = convertTimeString12to24(service.time) + ':00';
          newDateTime = date + 'T' + newTimeValue + zoneString;
        }

        if (service.dateFrom) {
          newDateFrom = format(new Date(service.dateFrom), 'yyyy-MM-dd');
        }
        if (service.dateTo) {
          newDateTo = format(new Date(service.dateTo), 'yyyy-MM-dd');
        }

        return {
          is_pickup: is_pickup,
          special_option_id: service.specialOptionId,
          code: service.code,
          ...(service.description ? { description: service.description } : {}),
          ...(service.contact_name ? { name: service.contact_name } : {}),
          ...(service.contact_phone ? { phone: service.contact_phone } : {}),
          ...(newDateFrom ? { first_date: newDateFrom } : {}),
          ...(newDateTo ? { second_date: newDateTo } : {}),
          ...(newDateTime ? { time: newDateTime } : {}),
        };
      });
  }

  async nextStepClick() {
    const isValid = await this.checkFromServicesValidation();
    if (!isValid) {
      this.$nextTick(() => {
        const el = this.$el.querySelector('.form-services-error:first-of-type') as HTMLElement;
        if (el) {
          this.$vuetify.goTo(el, { offset: 100 });
        }
      });
      return;
    } else {
      const payloadDelivery = this.createARServicesObject(this.ARServicesDeliveryList, false);
      const payloadPickup = this.createARServicesObject(this.ARServicesPickupList, true);
      this.$emit('setSpecialOptions', [...payloadDelivery, ...payloadPickup]);
      this.$emit('nextStepClick');
    }
  }

  public async checkFromServicesValidation() {
    const form = this.$refs.formServices as HTMLFormElement;
    if (form) {
      return await form.validate();
    }
    return false;
  }
}
